import type { ButtonProps } from "antd";
import type { RefObject } from "react";

import { FullscreenExitOutlined, FullscreenOutlined } from "@ant-design/icons";
import { BasicButton } from "#src/components/basic-button";
import { useFullscreen } from "ahooks";

export interface FullscreenButtonProps extends Omit<ButtonProps, "target"> {
	target: HTMLElement | (() => Element) | RefObject<Element>
	fullscreenIcon?: React.ReactNode
	fullscreenExitIcon?: React.ReactNode
}

/**
 * Fullscreen Button Component
 *
 * @param target Target element for fullscreen mode
 * @param fullscreenIcon Icon displayed when not in fullscreen
 * @param fullscreenExitIcon Icon displayed when in fullscreen
 * @param restProps Additional button properties
 * @returns Fullscreen button component
 */
export const FullscreenButton: React.FC<FullscreenButtonProps> = ({
																																		target,
																																		fullscreenIcon,
																																		fullscreenExitIcon,
																																		...restProps
																																	}) => {
	const [isFullscreen, { toggleFullscreen }] = useFullscreen(target);

	return (
		<BasicButton
			type="text"
			{...restProps}
			onClick={toggleFullscreen}

		>
			{!isFullscreen
				? (fullscreenIcon ?? <FullscreenOutlined />)
				: (fullscreenExitIcon
				  ?? <FullscreenExitOutlined />)}
		</BasicButton>
	);
};
